export default __webpack_public_path__ + "static/media/UpArow.5f4d7c46.svg";